import {
    getCustomerSubscription,
    listCustomerSubscriptions
} from './queries';
import {
    activateCustomerSubscription,
    cancelCustomerSubscription,
    createCustomerSubscription,
    deleteCustomerSubscription,
    updateCustomerSubscription,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {CustomerSubscription} from "../types.ts";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


export type ListCustomerSubscriptions = {
    listCustomerSubscriptions: { items: CustomerSubscription[], nextToken: string }
}

export type GetCustomerSubscription = {
    getCustomerSubscription: CustomerSubscription
}

export type CreateCustomerSubscription = {
    createCustomerSubscription: CustomerSubscription
}

export type UpdateCustomerSubscription = {
    updateCustomerSubscription: CustomerSubscription
}

export type ActivateCustomerSubscription = {
    activateCustomerSubscription: CustomerSubscription
}

export type CancelCustomerSubscription = {
    cancelCustomerSubscription: CustomerSubscription
}

export type DeleteCustomerSubscription = {
    deleteCustomerSubscription: string
}


const client = billingApiClient;


const normalizeFilter = (filter: { [key: string]: string }) =>
    Object.keys(filter).reduce((acc: { [key: string]: string }, key) => {
        if (filter[key] !== '' && filter[key] !== undefined) {
            acc[key] = filter[key];
        }
        return acc;
    }, {});

export const fetchRecords = async (query: ListRecordsQuery) => {
    const { filter, ...rest } = query;
    const transformedFilter = filter ? normalizeFilter(filter as { [key: string]: string }) : {};

    const response = await client.graphql<GraphQLQuery<ListCustomerSubscriptions>>({
                                                                               query: listCustomerSubscriptions,
                                                                               variables: {
                                                                                   ...rest,
                                                                                   ...(Object.keys(transformedFilter).length ? { filter: transformedFilter } : {})
                                                                               },
                                                                           });
    return {
        items: response.data?.listCustomerSubscriptions.items,
        nextToken: response.data?.listCustomerSubscriptions.nextToken,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetCustomerSubscription>>({
                                                                             query: getCustomerSubscription,
                                                                             variables: {id: id},
                                                                         });
    return response.data?.getCustomerSubscription;
};

export const add = async (payload: object) => {
    const response = await client.graphql<GraphQLQuery<CreateCustomerSubscription>>({
                                                                                query: createCustomerSubscription,
                                                                                variables: {input: payload},
                                                                            });
    return response.data?.createCustomerSubscription;
};

// `input` is already whitelisted to UpdateCustomerSubscriptionInput
// (buildUpdateCustomerSubscriptionInput); this layer sends it as given.
export const update = async (input: object) => {
    const response = await client.graphql<GraphQLQuery<UpdateCustomerSubscription>>({
                                                                                query: (updateCustomerSubscription),
                                                                                variables: {input},
                                                                            });
    return response.data?.updateCustomerSubscription;
};

export const activateRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<ActivateCustomerSubscription>>({
        query: activateCustomerSubscription,
        variables: { id }
    });
    return response.data?.activateCustomerSubscription;
};

export const cancelRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<CancelCustomerSubscription>>({
        query: cancelCustomerSubscription,
        variables: { id }
    });
    return response.data?.cancelCustomerSubscription;
};

export const deleteRecord = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<DeleteCustomerSubscription>>({
                                                                                query: (deleteCustomerSubscription),
                                                                                variables: {input: {id: id}},

                                                                            });
    return response.data?.deleteCustomerSubscription;
};
